<template>
  <div v-if="initialised" class="row">
    <div class="col-12">
      <advanced-filter
        :refs="$refs"
        :select-filters="selectFilters"
        :date-range="{ fromPlaceholder: 'Accepted from', toPlaceholder: 'Accepted to' }"
      />

      <v-server-table ref="table" :columns="columns" :options="options" :url="url" />
    </div>
  </div>
</template>

<script type="text/babel">
import entity from "../../mixins/entity";
import format from "../../mixins/format";
import AdvancedFilter from "../../components/common/AdvancedFilter.vue";

export default {
  components: {
    AdvancedFilter,
  },
  mixins: [entity, format],

  data() {
    return {
      initialised: false,

      selectFilters: {
        status: {
          options: [
            {
              label: "Pending",
              value: "Pending",
            },
            {
              label: "Sent",
              value: "Sent",
            },
            {
              label: "Paid",
              value: "Paid",
            },
            {
              label: "Refunded",
              value: "Refunded",
            },
          ],
        },
        is_quote: {
          options: [
            {
              label: "Quotes",
              value: "1",
            },
            {
              label: "Invoices",
              value: "0",
            },
          ],
        },
      },

      columns: [
        "invoice_number",
        "job",
        "job_contact",
        "billing_contact",
        "total",
        "accepted_at",
        "actions",
      ],
      options: {
        advancedFilter: true,
        orderBy: { ascending: false },
        sortable: ["invoice_number", "accepted_at"],
        templates: {
          invoice_number: (h, o) =>
            h("invoice-object", {
              props: {
                invoice: o,
                entityId: o.id,
              },
            }),
          job: (h, o) =>
            h("job-object", {
              props: {
                jobNumber: o.job_id,
                entityId: o.job_id,
                openNew: true,
              },
            }),
          total: (h, o) => this.formatCurrency(o.total),
          job_contact: (h, o) => this.$lodash.get(o, "job.job_contacts[0].name").trim(),
          billing_contact: (h, o) => {
            if (this.$lodash.has(o, "job.billing_contacts[0].id")) {
              return this.$lodash.get(o, "job.billing_contacts[0].name").trim();
            }

            return this.$lodash.get(o, "job.job_contacts[0].name").trim();
          },
          accepted_at: (h, o) => this.formatLocalDate(o.accepted_at),
          actions: (h, o) => {
            const icon = h("font-awesome-icon", {
              props: {
                icon: ["fal", "thumbs-up"],
              },
            });

            return h(
              "button",
              {
                class: "btn btn-primary btn-sm",
                on: {
                  click: () => {
                    this.process(o);
                  },
                },
              },
              [icon]
            );
          },
        },
      },
    };
  },

  computed: {
    url() {
      return "/invoices?with=job.jobContacts;job.billingContacts&orderBy=id&sortedBy=desc&accepted=1";
    },
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.selectFilters = {};
      this.initialised = true;
    },

    process(invoice) {
      return window
        .sweetAlert({
          title: "Are you sure?",
          text: "Please confirm marking the quote as Processed",
          icon: "info",
          dangerMode: true,
          buttons: {
            cancel: "No",
            confirm: "Yes",
          },
        })
        .then((choice) => {
          if (choice) {
            this.$http.put(`/invoices/${invoice.id}/process`).then((response) => {
              if (response.status === 200) {
                window.toastr.success("Quote marked as Processed!", "Success");
                this.init();

                this.$nextTick(() => {
                  this.$refs.table.refresh();
                  this.$refs.table.setPage(1);
                });
              }
            });
          }
        });
    },
  },
};
</script>
